import React, { useState } from 'react';
import { LogIn, Loader2, ExternalLink } from 'lucide-react';
import { useI18n } from '../i18n';
import { openInAppBrowser } from '../utils/browser';

const LoginForm = ({ onSubmit, isLoading }) => {
  const { t } = useI18n();
  const [loginData, setLoginData] = useState({
    identifier: '',
    password: '',
    rememberMe: true
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(loginData);
  };

  return (
    <div className="login-form-container">
      <h2>{t('login.title')}</h2>
      <p className="login-description">
        {t('login.description')}
      </p>
      
      <form onSubmit={handleSubmit} className="login-form">
        <input
          type="text"
          placeholder={t('login.handlePlaceholder')}
          value={loginData.identifier}
          onChange={(e) => setLoginData({ ...loginData, identifier: e.target.value })}
          disabled={isLoading}
          autoFocus
          autoComplete="username"
        />

        <input
          type="password"
          placeholder={t('login.passwordPlaceholder')}
          value={loginData.password}
          onChange={(e) => setLoginData({ ...loginData, password: e.target.value })}
          disabled={isLoading}
          autoComplete="current-password"
        />

        <div className="remember-me-container">
          <label className="remember-me-label">
            <input
              type="checkbox"
              checked={loginData.rememberMe}
              onChange={(e) => setLoginData({ ...loginData, rememberMe: e.target.checked })}
              disabled={isLoading}
              className="remember-me-checkbox"
            />
            {t('login.rememberMe')}
          </label>
        </div>

        <p className="app-password-hint">
          {t('login.appPasswordHint')}
        </p>

        <button type="submit" className="button button-primary" disabled={isLoading}>
          {isLoading ? (
            <>
              <Loader2 size={16} className="loading-spinner" />
              {t('login.loggingIn')}
            </>
          ) : (
            <>
              <LogIn size={16} />
              {t('login.loginButton')}
            </>
          )}
        </button>
      </form>

      <div className="login-footer">
        <button 
          type="button"
          className="create-app-password-link"
          onClick={() => openInAppBrowser('https://bsky.app/settings/app-passwords')}
        >
          <ExternalLink size={14} />
          {t('login.createAppPassword')}
        </button>
      </div>
    </div>
  );
};

export default LoginForm;
